import { gql } from "@apollo/client";

const LICENSE_BY_ID = gql`
  query license($id: Int!) {
    license(id: $id) {
      id
      title
      englishTitle
      fee
      currency
      duration
      status
      startDate
      endDate
      tournatedLicenseFee
      partnerLicenseFee
      isManagerPayingServiceFee
      isManagerPayingStripeFee
      isApprovalRequired
      isManagerPayingPlatformFee
      gender
      nationality
      ageFrom
      ageTo
      ageFromType
      ageToType
      licenseManager {
        id
        name
        email
        surname
      }
      federation {
        organizationName
        id
      }
      isSendNotificationsToManager
      additionalQuestions {
        id
        question
        fieldType
        fieldOptions
        askEachAthlete
        isMandatory
        isHide
      }
      leagues {
        id
        league {
          id
          title
          status
        }
      }
    }
  }
`;

export default LICENSE_BY_ID;
